import React from 'react';
import SvgIcon from './SvgIcon';

const NoMobilePhone = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.293 17.5H7a.5.5 0 00-.442.735l.735-.735zm.414 1H18a.5.5 0 000-1H8.707l-1 1zM7 3.5a.5.5 0 000 1h11a.5.5 0 000-1H7z"
            fill="currentColor"
        />
        <path
            d="M12.5 21a.5.5 0 100-1 .5.5 0 000 1z"
            fill="currentColor"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 2.692c0-.694.514-1.192 1.071-1.192h7.858c.557 0 1.071.498 1.071 1.192v4.6l1-1v-3.6C18.5 1.517 17.607.5 16.429.5H8.57C7.393.5 6.5 1.517 6.5 2.692v15.6l1-1v-14.6zm0 16.015l-1 1v1.6c0 1.176.893 2.193 2.071 2.193h7.858c1.178 0 2.071-1.017 2.071-2.192v-13.6l-1 1v12.6c0 .694-.514 1.192-1.071 1.192H8.57c-.557 0-1.071-.498-1.071-1.192v-2.6z"
            fill="currentColor"
        />
        <path
            d="M23.5 1L1 23.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

NoMobilePhone.displayName = 'NoMobilePhoneIcon';

export default NoMobilePhone;
